<template>
	<div class="container-fluid container-froDesk">
		<!-- Begin page -->
		<div class="wrapper">
			<div class="content-page content-froDesk">
				<div class="content">
					<div class="row">
						<!-- 科研动态 -->
						<div class="col-lg-8">
							<div id="card-left-1" class="card">
								<div class="card-body">
									<div class="dropdown float-right">
										<div class="dropdown-toggle arrow-none" title="更多" @click="toPublicList(10)"><i class="mdi mdi-chevron-right-box-outline"></i></div>
									</div>
									<h3 class="header-title froDeskHeader-tit mb-3 pb-2">
										<span class="tit">科研新闻</span>
										<span class="ml-1">Research Dynamics</span>
									</h3>
									<div class="con-froDesk-resDyn">
										<div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
											<el-carousel height="228px" indicator-position="none">
												<el-carousel-item v-for="item in list.researchLeft" :key="item.id">
													<div class="cur" @click="toDetailPage(item.id)">
														<!-- <img :src="item.thumbnailImage" class="d-block w-100" :alt="item.title"> -->
														<el-image
															fit="cover"
															style="width: 100%; height: 100%"
															:src="`${uploadUrl}/upload/download?id=${item.thumbnailImage}&openStyle=1`"
															:alt="item.title"
														>
															<div slot="placeholder" class="image-slot el-image__error">
																加载中
																<span class="dot">...</span>
															</div>
														</el-image>
														<p class="tit">{{ item.title }}</p>
													</div>
												</el-carousel-item>
											</el-carousel>
										</div>
										<ul class="froDesk-Lists">
											<li class="li_1" v-for="item in list.researchRigh" :key="item.id" @click="toDetailPage(item.id)">
												<i class="mdi mdi-arrow-right"></i>
												<a class="li_item">{{ item.title }}</a>
												<span class="time">{{ item.createTime ? item.createTime.substring(5, 10) : '' }}</span>
											</li>
										</ul>
									</div>
								</div>
								<!-- end card-body-->
							</div>
							<!-- end card-->
						</div>
						<!-- end 科研动态-->

						<!-- 通知公告 -->
						<div class="col-lg-4">
							<div id="card-right-1" class="card">
								<div class="card-body">
									<div class="dropdown float-right">
										<div class="dropdown-toggle arrow-none" title="更多" @click="toPublicList(11)"><i class="mdi mdi-chevron-right-box-outline"></i></div>
									</div>
									<h3 class="header-title froDeskHeader-tit mb-3 pb-2">
										<span class="tit">通知公告</span>
										<span class="ml-1">Notice</span>
									</h3>
									<ul class="froDesk-Lists froDesk-Lists-colour" style="min-height: 229px;">
										<li v-for="item in list.notice" :key="item.id" @click="toDetailPage(item.id)">
											<a class="li_item">
												<span v-if="item.important == 1" class="new">NEW</span>
												{{ item.title }}
											</a>
										</li>
									</ul>
								</div>
								<!-- end card-body -->
							</div>
							<!-- end card-->
						</div>
						<!-- end 通知公告 -->
					</div>

					<div class="row">
						<!-- 课题研究 -->
						<div class="col-lg-8">
							<div class="card">
								<div class="card-body">
									<div class="dropdown float-right">
										<a href="/subjectResearch" class="dropdown-toggle arrow-none" title="更多"><i class="mdi mdi-chevron-right-box-outline"></i></a>
									</div>
									<h3 class="header-title froDeskHeader-tit mb-3 pb-2">
										<span class="tit">课题研究</span>
										<span class="ml-1">Subject Research</span>
									</h3>

									<div class="table-responsive-sm table-Sub-sm">
										<el-table
											v-if="topicsList && topicsList.length > 0"
											:data="topicsList"
											stripe
											:header-cell-style="{ backgroundColor: '#7e9be2', color: '#fff' }"
											style="width: 100%"
										>
											<el-table-column prop="name" label="课题名称" min-width="100" show-overflow-tooltip align="left"></el-table-column>
											<el-table-column prop="unitName" label="承担单位" min-width="60" show-overflow-tooltip align="center"></el-table-column>
											<el-table-column prop="oneEmceeName" label="负责人" min-width="40" show-overflow-tooltip align="center"></el-table-column>
											<el-table-column prop="projectTypeName" label="课题类别" min-width="40" show-overflow-tooltip align="center"></el-table-column>
										</el-table>
										<!-- <table class="table table-striped table-centered table-Sub mb-0" v-if="topicsList && topicsList.length>0">
                      <thead>
                        <tr>
                          <th class="text-center">课题名称</th>
                          <th class="text-center">承担单位</th>
                          <th class="text-center">负责人</th>
                          <th class="text-center">课题级别</th>
                          <th class="text-center">课题类别</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in topicsList" :key="item.id">
                          <td>{{item.name}}</td>
                          <td class="text-center">{{item.unitName}}</td>
                          <td class="text-center">{{item.oneEmceeName}}</td>
                          <td class="text-center">{{item.classLever}}</td>
                          <td class="text-center">{{item.projectTypeName}}</td>
                        </tr>
                      </tbody>
                    </table> -->
									</div>
								</div>
								<!-- end card-body-->
							</div>
							<!-- end card-->
						</div>
						<!-- end 课题研究-->

						<!-- 快捷入口 -->
						<div class="col-lg-4">
							<div class="card">
								<div class="card-body">
									<h3 class="header-title froDeskHeader-tit mb-3 pb-2">
										<span class="tit">快捷入口</span>
										<span class="ml-1">Quick Access</span>
									</h3>
									<div class="row">
										<div class="col-4 col-sm-2 col-lg-4" v-for="item in quickAccessList" :key="item.id">
											<a class="quick-list" @click="toBackstage(item)">
												<div><img :src="item.imgUrl" class="d-block w-100" alt="课题管理" /></div>
												<p>{{ item.name }}</p>
											</a>
										</div>
									</div>
								</div>
								<!-- end card-body -->
							</div>
							<!-- end card-->
						</div>
						<!-- end 快捷入口 -->
					</div>

					<div class="row">
						<!-- 先进集体 -->
						<div class="col-lg-4">
							<div class="card">
								<div class="card-body">
									<div class="dropdown float-right">
										<div class="dropdown-toggle arrow-none" title="更多" @click="toPublicList(13)"><i class="mdi mdi-chevron-right-box-outline"></i></div>
									</div>
									<h3 class="header-title froDeskHeader-tit mb-3 pb-2">
										<span class="tit">先进集体</span>
										<span class="ml-1">Advanced Collective</span>
									</h3>
									<div class="row row-Adv" style="min-height: 255px;">
										<div class="col-6 col-sm-3 col-lg-6" v-for="item in list.collective" :key="item.id">
											<a class="Adv-list" @click="toDetailPage(item.id)">
												<div>
													<el-image
														fit="cover"
														style="width: 100%; height: 100%;"
														:src="`${uploadUrl}/upload/download?id=${item.thumbnailImage}&openStyle=1`"
														:alt="item.title"
													>
														<div slot="error" class="image-slot el-image__error" style="min-height: 100px;">暂无图片</div>
														<div slot="placeholder" class="image-slot el-image__error" style="min-height: 100px;">
															加载中
															<span class="dot">...</span>
														</div>
													</el-image>
													<!-- <img src="@/assets/images/yf_images/school_01.png" class="d-block w-100" :alt="item.title"> -->
												</div>
												<p>{{ item.title }}</p>
											</a>
										</div>
										<!-- end col-->
									</div>
								</div>
								<!-- end card-body-->
							</div>
							<!-- end card-->
						</div>
						<!-- end 先进集体-->

						<!-- 先进个人 -->
						<div class="col-lg-4">
							<div class="card">
								<div class="card-body">
									<div class="dropdown float-right">
										<div class="dropdown-toggle arrow-none" title="更多" @click="toPublicList(14)"><i class="mdi mdi-chevron-right-box-outline"></i></div>
									</div>
									<h3 class="header-title froDeskHeader-tit mb-3 pb-2">
										<span class="tit">先进个人</span>
										<span class="ml-1">Outstanding Person</span>
									</h3>
									<div class="row row-Per" style="min-height: 255px;">
										<div class="col-4 col-sm-2 col-lg-4" v-for="item in list.individual" :key="item.id">
											<a class="Per-list" @click="toDetailPage(item.id)">
												<div>
													<el-image
														fit="cover"
														style="width: 100%; height: 100%;"
														:src="`${uploadUrl}/upload/download?id=${item.thumbnailImage}&openStyle=1`"
														:alt="item.title"
													>
														<div slot="error" class="image-slot el-image__error">暂无图片</div>
														<div slot="placeholder" class="image-slot el-image__error">
															加载中
															<span class="dot">...</span>
														</div>
													</el-image>
													<!-- <img src="@/assets/images/yf_images/picture_7.jpg" class="d-block w-100" :alt="item.title"> -->
												</div>
												<p>{{ item.title }}</p>
											</a>
										</div>
										<!-- end col-->
									</div>
								</div>
								<!-- end card-body-->
							</div>
							<!-- end card-->
						</div>
						<!-- end 先进个人-->

						<!-- 相关下载 -->
						<div class="col-lg-4">
							<div class="card">
								<div class="card-body">
									<div class="dropdown float-right">
										<div class="dropdown-toggle arrow-none" title="更多" @click="toPublicList(15)"><i class="mdi mdi-chevron-right-box-outline"></i></div>
									</div>
									<h3 class="header-title froDeskHeader-tit mb-3 pb-2">
										<span class="tit">相关下载</span>
										<span class="ml-1">Downloads</span>
									</h3>
									<ul class="froDesk-Lists froDesk-Lists-colour" style="min-height: 239px;">
										<li v-for="item in list.relatedDownloads" :key="item.id" @click="toDetailPage(item.id)">
											<a>
												<span v-if="item.important == 1" class="new">NEW</span>
												{{ item.title }}
											</a>
										</li>
									</ul>
								</div>
								<!-- end card-body-->
							</div>
							<!-- end card-->
						</div>
						<!-- end 相关下载-->
					</div>
				</div>
			</div>
		</div>
		<Login :url="accessLogin.url" :isDialogLoginShow="accessLogin.dialogLoginShow" :showLoginBtn="accessLogin.showLoginBtn" @dialogloginshow="dialogloginshowChange"></Login>
	</div>
</template>

<script>
import { getHomeAtrticle, getResearchTopicsList } from '@/api/before/home';
import Login from '@/components/Login';

export default {
	components: { Login },
	data() {
		return {
			list: [],
			topicsList: [],
			quickAccessList: [
				{
					id: 1,
					name: '课题申报',
					imgUrl: require('@/assets/images/yf_images/quick_01.png'),
					url: '/backstage/topicsDeclaration'
				},
				{
					id: 2,
					name: '课题管理',
					imgUrl: require('@/assets/images/yf_images/quick_02.png'),
					url: '/backstage/topicSummary'
				},
				{
					id: 3,
					name: '征文评审',
					imgUrl: require('@/assets/images/yf_images/quick_03.png'),
					url: '/backstage/mySubmitted'
				},
				{
					id: 4,
					name: '成果评审',
					imgUrl: require('@/assets/images/yf_images/quick_04.png'),
					url: '/backstage/schoolManageAchievement'
				},
				{
					id: 5,
					name: '先进个人评选',
					imgUrl: require('@/assets/images/yf_images/quick_05.png'),
					url: '/backstage/schoolManageIndividual'
				},
				{
					id: 6,
					name: '先进集体评选',
					imgUrl: require('@/assets/images/yf_images/quick_06.png'),
					url: '/backstage/schoolManageCollective'
				}
			], //快捷入口列表
			accessLogin: { url: '', dialogLoginShow: false, showLoginBtn: false }
		};
	},
	mounted() {
		this.getData();
		this.getResearchTopicsList();
	},
	methods: {
		getData() {
			getHomeAtrticle(this.query).then(res => {
				if (res.code == 200) {
					this.list = res.data;
					this.list.researchLeft = this.list.researchLeft.splice(0, 5);
					this.list.researchRigh = this.list.researchRigh.splice(0, 6);
					this.list.notice = this.list.notice.splice(0, 6);
					this.list.collective = this.list.collective.splice(0, 4);
					this.list.individual = this.list.individual.splice(0, 6);
					this.list.relatedDownloads = this.list.relatedDownloads.splice(0, 6);
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		getResearchTopicsList() {
			let topicsQuery = {
				pageNumber: 1,
				pageSize: 6,
				pageSorts: [{ asc: true, column: '' }]
			};
			getResearchTopicsList(topicsQuery).then(res => {
				if (res.code == 200) {
					this.topicsList = res.data.records;
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		toPublicList(type) {
			this.$router.push('/publicList/' + type);
		},
		toDetailPage(id) {
			let routerJump = this.$router.resolve({ path: '/publicDetails/' + id });
			window.open(routerJump.href, '_blank');
		},
		toBackstage(item) {
			if (!item.url && item.url == '') {
				this.$message('此栏目正在建设中！');
				return;
			}
			let token = sessionStorage.getItem('token');
			if (!token) {
				this.accessLogin.url = item.url;
				this.accessLogin.dialogLoginShow = true;
				return;
			}
			this.$router.push(item.url);
		},
		// 登录框变化
		dialogloginshowChange(val) {
			this.accessLogin.dialogLoginShow = val;
		}
	}
};
</script>
<style >
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #f1f3fa;
}
</style>
<style scoped lang="scss">
/* 首页-科研动态 */
.con-froDesk-resDyn .cur {
  position: relative;
  height: 100%;
}
.con-froDesk-resDyn .cur img {
  height: 100%;
  min-width: 100%;
}
.con-froDesk-resDyn .tit {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin-bottom: 0;
  padding: 6px 12px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.3);
  color: #fff;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.con-froDesk-resDyn {
  position: relative;
  padding-left: 334px;
  height: 228px;
}
.con-froDesk-resDyn .carousel {
  position: absolute;
  top: 0;
  left: 0;
  width: 304px;
  height: 228px;
  overflow: hidden;
}
.con-froDesk-resDyn .carousel-indicators {
  margin-bottom: 28px;
}
.con-froDesk-resDyn .carousel-item {
  position: relative;
  width: 304px;
  height: 228px;
  overflow: hidden;
}
.con-froDesk-resDyn .carousel-item img {
  display: block;
  max-width: 100%;
  min-height: 100%;
}
.con-froDesk-resDyn .carousel-item p {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin-bottom: 0;
  padding: 6px 12px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.3);
  color: #fff;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/* 课题研究 */
.table-Sub-sm {
  min-height: 232px;
  overflow: auto;
}
.table-Sub thead th {
  background-color: #7e9be2;
  color: #fff;
  word-break: keep-all;
  white-space: nowrap;
  height: 40px;
  line-height: 40px;
}
.table-Sub thead th,
.table-Sub tbody td {
  padding: 0 15px;
  border-top: 0;
}
.table-Sub tbody td {
  height: 38px;
  line-height: 38px;
}
.table-Sub a {
  display: block;
}

/* 快捷入口 */
.quick-list {
  display: block;
  height: 116px;
  text-align: center;
}
.quick-list div {
  margin: 0 auto 10px;
  width: 58px;
  height: 58px;
}

/* 先进集体 */
.row-Adv {
  margin-bottom: -20px;
}
.Adv-list {
  position: relative;
  margin-bottom: 20px;
  display: block;
  min-height: 100px;
}
.Adv-list div {
  width: 100%;
  overflow: hidden;
}
.Adv-list div img {
  display: block;
  max-width: 100%;
  min-height: 100%;
}
.Adv-list p {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin-bottom: 0;
  padding: 6px 12px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.3);
  color: #fff;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* 先进个人 */
.row-Per {
  margin-bottom: -17px;
}
.Per-list {
  display: block;
  text-align: center;
}
.Per-list div {
  margin: 0 auto 5px;
  width: 86px;
  height: 86px;
  border-radius: 50%;
  overflow: hidden;
}
.Per-list div img {
  display: block;
  max-width: 100%;
  min-height: 100%;
}
</style>